'use client';

import { captureException } from '@sentry/nextjs';
import {
  ErrorBoundary as ReactErrorBoundary,
  type ErrorBoundaryPropsWithFallback,
} from 'react-error-boundary';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback: ErrorBoundaryPropsWithFallback['fallback'];
};

export function ErrorBoundary({ children, fallback }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      fallback={fallback}
      onError={(error: Error) => {
        captureException(error, {
          extra: {
            scope: 'react error boundary',
          },
        });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
